<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      @openAddDialog="openAddDialog"
      :show="false"
      :selectShow="false"
      addShowPower="/gloryangel/add"
      buttonName="添加"
    >
    </common-top-form>
    <common-table
      :data="tableData"
      ref="commonTable"
      @handleChange="getPage"
      :isShow="false"
    >
      <el-table-column
        prop="tatName"
        label="机构名"
        min-width="100"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="realName"
        label="姓名"
        min-width="160"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="phoneNumber"
        label="手机号"
        min-width="160"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作" min-width="220">
        <template slot-scope="scope">
          <el-button type="text" @click="openAddDialog(scope.row)"
            >调账
          </el-button>
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="itemId ? '调账' : '调账'"
      :model="dialogModel"
      :submitData="dialogData"
      labelWidth="120px"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      class="note"
    >
      <el-form-item label="姓名" prop="realName" label-width="140px">
        <el-input
          style="width: 200px"
          type="text"
          maxlength="100"
          v-model="dialogModel.realName"
          placeholder="请输入"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phoneNumber" label-width="140px">
        <el-input
          style="width: 200px"
          type="text"
          maxlength="10"
          v-model="dialogModel.phoneNumber"
          placeholder="请输入"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item label="金额" prop="withdrawSum" label-width="140px">
        <el-input
          style="width: 200px"
          type="text"
          maxlength="100"
          v-model="this.withdrawSum"
          placeholder="请输入"
          disabled
        ></el-input>
        <span>元</span>
      </el-form-item>
      <el-form-item label="调账金额" prop="money" label-width="140px">
        <el-input
          style="width: 200px"
          type="text"
          maxlength="100"
          v-model="dialogModel.money"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";
import ShowInfoDialog from "../../dialog/ShowInfoDialog";

// 状态和类型
import MemberLevelService from "service/MemberLevelService";
import TimeRange from "service/constant/TimeRange";
import FinanceService from "service/FinanceService";

import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "financialreconciliation",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
    ShowInfoDialog,
  },
  data() {
    return {
      // 标题
      itemId: "",
      formModel: {},
      tableData: [],
      submitService: MemberLevelService.accountList,
      Configure: MemberLevelService.accountadjustmentList,
      page: {},
      isPage: false,
      withdrawSum: "",
      dialogModel: {
        realName: "",
        phoneNumber: "",
        money: "",
      },
      dialogRules: {
        money: [
          {
            required: true,
            message: "请输入调账金额",
          },
        ],
      },
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
    this.page = this.$refs.commonTable.page;
  },
  computed: {
    submitData() {
      this.params = {};
      return this.params;
    },
    dialogData() {
      const params = {
        money: this.dialogModel.money * 100,
      };
      if (this.itemId) {
        params.userId = this.itemId;
      }
      return params;
    },
    dialogService() {
      return MemberLevelService.accountadjustmentEdit;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  watch: {},
  methods: {
    load() {
      this.formModel = {};
      this.getList();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    // 配置
    openAddDialog(item) {
      this.itemId = item ? item.id : "";
      if (this.itemId) {
        this.dialogModel = JSON.parse(JSON.stringify(item));
      }
      this.getConfigure(item);
      this.$refs.formDialog.open();
    },
    getConfigure(item) {
      this.doLoad(
        this.Configure,
        {
          id: item.id,
          tatId: item.tatId,
          simpleTatId: item.tatId,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.withdrawSum = res.contents.withdrawSum / 100;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    // 弹框关闭清空数据
    dialogClose() {
      this.dialogModel = {
        realName: "",
        phoneNumber: "",
        money: "",
      };
      this.itemId = "";
      this.withdrawSum = "";
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
  },
};
</script>
<style scoped>
.mem-name p {
  margin-bottom: 20px;
  vertical-align: middle;
  line-height: 40px;
  color: rgba(170, 170, 170, 1);
}

.mem-name p:first-child {
  display: inline-block;
  width: 90px;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
}
.el-tooltip p {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/view/page/FinanceManage/FinancialReconciliation.vue